module.exports = __webpack_public_path__ + "img/MOS Burger.ac260e27.svg";